import { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import PageCTA from "@/components/PageCTA";
import { HERO_FAQ } from "@/components/heroBg";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FAQ = () => {
  const [faq, setFaq] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/faq`).then(res => {
      setFaq(res.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen" data-testid="faq-page">
      <div className="subpage-hero subpage-hero--bg flex items-end" style={HERO_FAQ}>
        <div className="container pb-0">
          <p className="eyebrow mb-4">FAQ</p>
          <h1 className="font-heading text-[clamp(36px,5vw,56px)] text-[var(--color-text-light)] mb-4">
            Najczęstsze pytania
          </h1>
          <p className="lead max-w-xl">Sprawdź, jak wygląda współpraca, realizacja projektu, przekazanie materiałów i dalsze wsparcie.</p>
        </div>
      </div>

      <div className="section bg-[var(--color-cream)]">
        <div className="container max-w-3xl mx-auto">
          {loading ? (
            <div className="space-y-4">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="h-16 bg-[var(--color-white)] rounded animate-pulse border border-[var(--color-border-light)]" />
              ))}
            </div>
          ) : (
            <Accordion type="single" collapsible>
              {faq.map((item, idx) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.05 }}
                >
                  <AccordionItem
                    value={item.id}
                    className="border-b border-[var(--color-border-light)]"
                    data-testid={`faq-item-${idx}`}
                  >
                    <AccordionTrigger className="text-left font-heading text-lg font-medium text-[var(--color-text-dark)] hover:text-[var(--color-gold)] py-6 hover:no-underline transition-colors">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent className="font-body text-[var(--color-text-muted)] pb-6 text-sm leading-relaxed">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                </motion.div>
              ))}
            </Accordion>
          )}
        </div>
      </div>
      <PageCTA />
    </div>
  );
};

export default FAQ;
